/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Detecting_TextInputs */

const en_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecting shot changes...`)
};

const fr_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detection des changements de plan...`)
};

const de_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkennung von Szenenwechseln...`)
};

const it_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento dei cambiamenti di tiro...`)
};

const ru_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение изменений в кадре...`)
};

const es_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectando cambios de toma...`)
};

const zh_cn2_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测投篮变化……`)
};

const ja_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの変更を検出しています...`)
};

const hi_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट में बदलाव का पता लगाना...`)
};

const pt_pt2_scene_change_detection_detecting_text = /** @type {(inputs: Scene_Change_Detection_Detecting_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectando mudanças de tiro...`)
};

/**
* | output |
* | --- |
* | "Detecting shot changes..." |
*
* @param {Scene_Change_Detection_Detecting_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_detecting_text = /** @type {((inputs?: Scene_Change_Detection_Detecting_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Detecting_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_detecting_text(inputs)
	if (locale === "de") return de_scene_change_detection_detecting_text(inputs)
	if (locale === "it") return it_scene_change_detection_detecting_text(inputs)
	if (locale === "ru") return ru_scene_change_detection_detecting_text(inputs)
	if (locale === "es") return es_scene_change_detection_detecting_text(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_detecting_text(inputs)
	if (locale === "ja") return ja_scene_change_detection_detecting_text(inputs)
	if (locale === "hi") return hi_scene_change_detection_detecting_text(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_detecting_text(inputs)
	return en_scene_change_detection_detecting_text(inputs)
});